import { Component } from 'react'
import { withRouter,matchPath } from 'react-router-dom'

let lastLocation = null 


class LastLocationProvider extends Component {
 
	UNSAFE_componentWillReceiveProps(nextProps) {
		if(lastLocation === 'search'){
			lastLocation = null
		}
		else{
			if(this.props.location){
				if(matchPath(this.props.location.pathname, { path:'/setreport/:pollId/:pollPollId',isExact:true})){

					return
				}

			}
			if(nextProps.location){
				if(matchPath(nextProps.location.pathname, { path:'/setreport/:pollId/:pollPollId',isExact:true})){
					return 
				}
			}
			if (this.props.location === nextProps.location) {
				return
			}
		
			lastLocation = {
				...this.props.location,
			}

		
			if (this.props.location.pathname === nextProps.location.pathname) {
				return
			}

			lastLocation = {
				...this.props.location,
			}
		}
	}


	render() {
		return this.props.children
	}
}

export function getLastLocation(){
	return lastLocation
}
export function setLastLocation(manualLastLocation){
	lastLocation =  manualLastLocation
	return lastLocation
}
export default withRouter(LastLocationProvider)